import { createContext, useMemo, useState, useEffect } from 'react';
import { usePreference } from './usePreference';
import PropTypes from 'prop-types';
import {
  getUserPreferenceLocalStorage,
} from "./utils";

const mobileBreakpointWidth = 935;
const landscapeBreakpointHeight = 320;
const detailShortHeight = 560;
const smallColumnWidth = 60;
const mediumColumnWidth = 106;
const defaultChartHeight = 264;
const smallHeight = 400;
const shortHeightChartBreakpoint = 200;

export const UiContext = createContext();

const UiProvider = ({ children }) => {

  const calculateAbsoluteWidthsWithLimits = (headerWidth, headerWidth2, minWidth = 120) => {
    let headerWidthAbsolute = window.innerWidth * headerWidth / 100;
    let headerWidth2Absolute = window.innerWidth * headerWidth2 / 100;

    if (headerWidthAbsolute < minWidth) {
      const difference = minWidth - headerWidthAbsolute;
      headerWidthAbsolute = minWidth;
      headerWidth2Absolute = headerWidth2Absolute - difference;
    }

    return [headerWidthAbsolute, headerWidth2Absolute];
  };
  const calculateEmissorasColumn = (emissorasList, minWidthMobile = 64, minWidthDesktop = 105) => {
    let emissoraWidth = 0;
    if (emissorasList && emissorasList.length > 0) {
      emissoraWidth = minuteHeaderWidth2Absolute / emissorasList.length;
      if (window.innerWidth <= mobileBreakpointWidth) {
        emissoraWidth = emissoraWidth <= minWidthMobile ? minWidthMobile : emissoraWidth;
      } else {
        emissoraWidth = emissoraWidth <= minWidthDesktop ? minWidthDesktop : emissoraWidth;
      }
    }
    return emissoraWidth;
  };
  const calculateEmissorasColumnInt = (count, minWidthMobile = 64, minWidthDesktop = 105) => {
    let emissoraWidth = 0;
    emissoraWidth = minuteHeaderWidth2Absolute / count;
    if (window.innerWidth <= mobileBreakpointWidth) {
      emissoraWidth = emissoraWidth <= minWidthMobile ? minWidthMobile : emissoraWidth;
    } else {
      emissoraWidth = emissoraWidth <= minWidthDesktop ? minWidthDesktop : emissoraWidth;
    }

    return emissoraWidth;
  };
  let user = getUserPreferenceLocalStorage() ?? { baseID: 0 };
  let colSpanSize = user.baseID === 0 ? 2 : 1;


  let minuteHeaderWidth = colSpanSize * 8;
  let minuteHeaderWidth2 = 100 - minuteHeaderWidth;
  let minuteHeaderWidthAbsolute = calculateAbsoluteWidthsWithLimits(minuteHeaderWidth, minuteHeaderWidth2)[0];
  let minuteHeaderWidth2Absolute = calculateAbsoluteWidthsWithLimits(minuteHeaderWidth, minuteHeaderWidth2)[1];

  let mediaHeaderWidth = colSpanSize * 8;
  let mediaHeaderWidth2 = 100 - mediaHeaderWidth;
  let mediaHeaderWidthAbsolute = calculateAbsoluteWidthsWithLimits(mediaHeaderWidth, mediaHeaderWidth2)[0];
  let mediaHeaderWidth2Absolute = calculateAbsoluteWidthsWithLimits(mediaHeaderWidth, mediaHeaderWidth2)[1];

  const [state, setState] = useState({
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    isMobile: window.innerWidth <= mobileBreakpointWidth,
    hasShortWidth: window.innerWidth <= smallColumnWidth,
    hasShortHeight: window.innerHeight <= landscapeBreakpointHeight,
    hasShortHeightDetail: window.innerHeight < detailShortHeight,
    hasSmallHeight: window.innerHeight <= smallHeight,
    menuClosed: true,
    submenu: null,
    panel: null,
    screen: null,
    chartVisible: true,
    secondTableVisible: false,
    splitScreenMenuClosed: true,
    displaySplash: true,
    error: null,
    warning: null,
    selectedMonth: null,
    secondarySelectedMonth: null,
    rowsType: 'detailed', // Adicionei rowsType ao estado
    minuteHeaderWidthAbsolute: minuteHeaderWidthAbsolute,
    minuteHeaderWidth2Absolute: minuteHeaderWidth2Absolute,
    mediaHeaderWidthAbsolute: mediaHeaderWidthAbsolute,
    mediaHeaderWidth2Absolute: mediaHeaderWidth2Absolute,
    channelsLength: 0,
    minuteGraphic: null,
    mediaComp: null,
  });
  useEffect(() => {

    const handleResize = () => {
      let minuteAbsolute1 = calculateAbsoluteWidthsWithLimits(minuteHeaderWidth, minuteHeaderWidth2)[0];
      let minuteAbsolute2 = calculateAbsoluteWidthsWithLimits(minuteHeaderWidth, minuteHeaderWidth2)[1];
      let mediaAbsolute1 = calculateAbsoluteWidthsWithLimits(mediaHeaderWidth, mediaHeaderWidth2)[0];
      let mediaAbsolute2 = calculateAbsoluteWidthsWithLimits(mediaHeaderWidth, mediaHeaderWidth2)[1];
      let minuteHeaderWidthAbsolute = window.innerWidth * minuteHeaderWidth / 100;
      minuteHeaderWidthAbsolute = minuteHeaderWidthAbsolute <= 120 ? 120 : minuteHeaderWidthAbsolute;
      let mediaHeaderWidthAbsolute = window.innerWidth * mediaHeaderWidth / 100;
      mediaHeaderWidthAbsolute = mediaHeaderWidthAbsolute <= 120 ? 120 : mediaHeaderWidthAbsolute;
      setState((prevState) => ({
        ...prevState,
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        isMobile: window.innerWidth <= mobileBreakpointWidth,
        hasShortWidth: window.innerWidth <= smallColumnWidth,
        hasShortHeight: window.innerHeight <= landscapeBreakpointHeight,
        hasShortHeightDetail: window.innerHeight < detailShortHeight,
        hasSmallHeight: window.innerHeight < smallHeight,
        minuteHeaderWidthAbsolute: minuteAbsolute1,
        minuteHeaderWidth2Absolute: minuteAbsolute2,
        mediaHeaderWidthAbsolute: mediaAbsolute1,
        mediaHeaderWidth2Absolute: mediaAbsolute2,

        minuteGraphic: document.querySelector('#minuteGraphic')?.getBoundingClientRect(),
        mediaComp: document.querySelector('#DivMedComp')?.getBoundingClientRect(),
      }));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const updateElementRects = (minuteChart, medComp) => {
    setState((prevState) => ({
      ...prevState,
      minuteGraphic: minuteChart?.getBoundingClientRect(),
      mediaComp: medComp?.getBoundingClientRect(),
    }));
  };
  const setChannelsLength = (length) => {
    setState(prevState => ({
      ...prevState,
      channelsLength: length
    }));
  };
  const pChartHeight = useMemo(() => {
    return (
      !state.chartVisible ||
      state.hasShortHeight ||
      (state.hasShortHeightDetail && state.rowsType === 'detailed')
    ) ? 30 : defaultChartHeight;
  }, [state.chartVisible, state.hasShortHeight, state.hasShortHeightDetail, state.rowsType]);
  const columnCalculations = useMemo(() => {
    let columnWidth = state.isMobile ? smallColumnWidth : mediumColumnWidth;
    let columnNumHeader = (user.baseID === 0) ? 2 : 1;
    let columnNum = (user.baseID === 0) ? 1 : 0;
    let tableContentWidth = (state.channelsLength + columnNum) * columnWidth;

    columnWidth = tableContentWidth > state.screenWidth ? columnWidth :
      Math.ceil((state.screenWidth) / (state.channelsLength + columnNumHeader));

    let columnWidthHeader = (columnWidth * columnNumHeader);

    return {
      columnWidth,
      columnNumHeader,
      columnNum,
      tableContentWidth,
      columnWidthHeader
    };
  }, [state.isMobile, state.screenWidth, state.channelsLength, user.baseID]);

  const contextValue = useMemo(() => ({
    ...state,
    pChartHeight,
    updateElementRects,
    setChannelsLength,
    ...columnCalculations,
    calculateEmissorasColumn,
    calculateEmissorasColumnInt
  }), [state, pChartHeight, columnCalculations]);


  return (
    <UiContext.Provider value={contextValue}>
      {children}
    </UiContext.Provider>
  );
};
UiProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default UiProvider;